module.exports = __webpack_public_path__ + "static/media/Moscow.3a4273e7.jpg";